import styled from 'styled-components';

import {
  Dropdown as SemanticDropdown,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  margin-top: 5px;
  padding: 0px 10px;
  width: 100%;
`;

const OtherDetails = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

const Detail = styled(TextLayoutComponent)`
  margin-bottom: 5px;
  margin-left: ${(props) => (props.left ? `${props.left}px` : '0px')}
`;

const DetailFaceRecording = styled(TextLayoutComponent)`
  margin-top: -15px;
  margin-bottom: 5px;
  margin-left: ${(props) => (props.left ? `${props.left}px` : '0px')}
`;

const Tester = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0px;
`;

const TesterName = styled(TextLayoutComponent.Bold)`
  width: 350px;
`;

const ButtonRemove = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-left: 20px;
    width: 100px;
  }
`;

const ButtonInvite = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-left: 20px;
    width: 100px;
  }
`;

const ButtonMoveDraft = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-right: 10px;
    width: 150px;
  }
`;

const Dropdown = styled(SemanticDropdown)`
  &.ui.search.dropdown {
    width: 320px;
  }
`;

const LoadMore = styled.a`
  cursor: pointer;
`;

const LoadMoreContainer = styled.div`
  margin-top: 20px;
`;

const LinkedInUrl = styled.a`
  margin-left: 20px;
`;

const Link = styled.a`
  margin-left: 20px;
`;

const ContainerSpace = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2em;
`;

const ContainerParticipants = styled.div`
  display: flex;
`;

const UserInterviewsLinksContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
`;

const UserInterviewsSegmentLinks = styled.div`
`;

const UserInterviewsLink = styled.a`
`;

export {
  ButtonInvite,
  ButtonRemove,
  Container,
  Detail,
  DetailFaceRecording,
  Dropdown,
  OtherDetails,
  Tester,
  TesterName,
  Link,
  LoadMore,
  LoadMoreContainer,
  LinkedInUrl,
  ContainerSpace,
  ContainerParticipants,
  ButtonMoveDraft,
  UserInterviewsLinksContainer,
  UserInterviewsSegmentLinks,
  UserInterviewsLink,
};
